import styled from 'styled-components'

const DownloadLink = styled.div`
    color: var(--pink);
    cursor: pointer;
`

export {
    DownloadLink,
}